.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .form-wrapper {
    min-width: 500px;
    width: 100%;
    height: auto;
    overflow-y: scroll;

    #readonly-notice {
      margin-bottom: calc(var(--spacer) * 3);
    }
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .form-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }
}

.bottom-buttons {
  width: 100%;
  flex-basis: 65px;
  min-height: 65px;
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  border-top: 1px solid var(--chart-101-pressed-dividers);

  gz-button {
    margin-right: calc(var(--spacer) * 2);
  }
}
